import React from "react";
import ResImg from "../../assets/img/404.svg";

const PageNotFound = () => {
  return (
    <div className="response-page">
      <div className="res-img">
        <img src={ResImg} alt="Page Not Found" />
      </div>
      <h3 style={{ color: "#91298C" }}>
        <span className="text-white">Oops, Page</span> Not Found
      </h3>
      <p>
        Sorry the page you are looking for cannot be found. You might have typed
        wrong URL or have lost the internet connection.
      </p>
    </div>
  );
};

export default PageNotFound;
